module.exports = __webpack_public_path__ + "media/bootstrap-icons/toggle-off-535044cf.svg";